import { useState } from 'react';
import { Flex, Stack } from '@chakra-ui/react';

import PageLayout from '../layouts/PageLayout';
import FullHome from '../ui/FullHome';
import { LensMe } from '../ui/LensMe';
import PushDownButton from '../ui/PushDownButton';

function HomePage() {
  const [showCard, setShowCard] = useState(false);
  const buttonText = showCard ? 'back' : 'flip my card';

  const toggleShowCard = () => {
    setShowCard(!showCard);
  };

  return (
    <PageLayout seoKey="home">
      <Stack
        w="100%"
        maxW="1100px"
        px={{ base: 4, md: 8 }}
        py={{ base: 4, md: 6 }}
        spacing={4}
      >
        <Flex justify="flex-end">
          <PushDownButton
            buttonText={buttonText}
            setShowCard={toggleShowCard}
          />
        </Flex>

        {showCard ? <LensMe /> : <FullHome />}
      </Stack>
    </PageLayout>
  );
}

export default HomePage;
